<!-- <template>
  <div class="overlay" @click.self="closePopup">
    <div class="popup">
      <h2>Save File</h2>
      <div class="form-group">
        <label for="fileName">File Name</label>
        <input
          type="text"
          id="fileName"
          v-model="currentEmailTitle"
          @input="validateFileName"
          :class="{ invalid: fileNameInvalid }"
        />
        <span v-if="fileNameInvalid" class="error-message">Invalid file name. Only letters, numbers, hyphens, and underscores are allowed.</span>
      </div>
      <div class="form-group">
        <label for="fileType">File Type</label>
        <select v-model="fileType" id="fileType">
          <option value="Boilerplate">Boilerplate</option>
          <option value="MailTemplate">MailTemplate</option>
        </select>
      </div>
      <div class="button-group">
        <button @click="saveFile" :disabled="fileNameInvalid">Save</button>
        <button @click="closePopup">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters} from 'vuex';
import { convertJsonToHtml } from '@/utils/convertJsonToHtml';

export default {
  name: 'SaveFile',
  data() {
    return {
      fileType: 'Boilerplate',
      fileNameInvalid: false,
    };
  },
  computed: {
    ...mapState(['emailData']),
    ...mapGetters(['getEmailTitle']),
    currentEmailTitle: {
      get() {
        return this.getEmailTitle;
      },
      set(value) {
        this.updateEmailTitle(value);
      }
  }},
  methods: {
    ...mapActions(['updateEmailTitle']),
    validateFileName() {
      const validPattern = /^[a-zA-Z0-9-_]+$/;
      this.fileNameInvalid = !validPattern.test(this.fileName);
    },
    saveFile() {
      if (this.fileType === 'MailTemplate') {
        const htmlContent = convertJsonToHtml(this.emailData);
        this.downloadFile(htmlContent, `${this.currentEmailTitle}.html`, 'text/html');
      } else {
        const jsonData = JSON.parse(JSON.stringify(this.emailData));
        delete jsonData.root;
        const jsonContent = JSON.stringify(jsonData, null, 2);
        this.downloadFile(jsonContent, `${this.currentEmailTitle}.json`, 'application/json');
      }
      this.closePopup();
    },
    downloadFile(content, fileName, contentType) {
      const a = document.createElement('a');
      const file = new Blob([content], { type: contentType });
      a.href = URL.createObjectURL(file);
      a.download = fileName;
      a.click();
    },
    closePopup() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  text-align: left;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input,
select {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.invalid {
  border-color: red;
}

.error-message {
  color: red;
  font-size: 12px;
}

.button-group {
  display: flex;
  justify-content: space-between;
}

button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button[disabled] {
  background: #ccc;
  cursor: not-allowed;
}

button:not([disabled]) {
  background: #05bbef;
  color: white;
}

button:not([disabled]):hover {
  background: #028ec2;
}
</style>
 -->
<template>
  <div class="overlay" @click.self="closePopup">
    <div class="popup">
      <h2>{{ $t('SaveFile.SaveFile') }}</h2>
      <div class="form-group">
        <label for="fileName">{{ $t('SaveFile.FileName') }}</label>
        <input
          type="text"
          id="fileName"
          v-model="currentEmailTitle"
          @input="validateFileName"
          :class="{ invalid: fileNameInvalid }"
        />
        <span v-if="fileNameInvalid" class="error-message">{{ $t('SaveFile.ErrorMessage') }}</span>
      </div>
      <div class="form-group">
        <label for="fileType">{{ $t('SaveFile.FileType') }}</label>
        <select v-model="fileType" id="fileType">
          <option value="Boilerplate">{{ $t('SaveFile.Boilerplate') }}</option>
          <option value="MailTemplate">{{ $t('SaveFile.MailTemplate') }}</option>
          <option value="DeploymentPackage">{{ $t('SaveFile.DeploymentPackage') }}</option>
          <option value="XML">{{ $t('SaveFile.XML') }}</option>
        </select>
      </div>
      <div class="button-group">
        <button @click="saveFile" :disabled="fileNameInvalid">{{ $t('SaveFile.Save') }}</button>
        <button @click="closePopup">{{ $t('SaveFile.Cancel') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { convertJsonToHtml } from '@/utils/convertJsonToHtml';
import { generateForDocEngine } from '@/utils/generateForDocEngine';
import { generateMetaXML } from '@/utils/createMetaXml';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';


export default {
  name: 'SaveFile',
  data() {
    return {
      fileType: 'Boilerplate',
      fileNameInvalid: false,
    };
  },
  computed: {
    ...mapState(['emailData', 'mediaQueries', 'xPathPlaceholders', 'xmlFile']),
    ...mapGetters(['getEmailTitle']),
    currentEmailTitle: {
      get() {
        return this.getEmailTitle;
      },
      set(value) {
        this.updateEmailTitle(value);
      }
    }
  },
  methods: {
    ...mapActions(['updateEmailTitle']),
    validateFileName() {
      const validPattern = /^[a-zA-Z0-9-_]+$/;
      this.fileNameInvalid = !validPattern.test(this.currentEmailTitle);
    },
    async saveFile() {
      const emailTitle = this.currentEmailTitle || 'NewTemplate';
      
      if (this.fileType === 'MailTemplate') {
        const htmlContent = convertJsonToHtml(this.emailData, false);
        this.downloadFile(htmlContent, `${emailTitle}.html`, 'text/html');
      }else if (this.fileType === 'XML') {
        const xmlContent = this.xmlFile;
        this.downloadFile(xmlContent, `${emailTitle}_design.xml`, 'text/xml'); 
      } else if (this.fileType === 'Boilerplate') {
        const jsonData = JSON.parse(JSON.stringify(this.emailData));
        delete jsonData.root;
        const jsonContent = JSON.stringify(jsonData, null, 2);
        this.downloadFile(jsonContent, `${emailTitle}.json`, 'application/json');
      } else if (this.fileType === 'DeploymentPackage') {
        await this.createDeploymentPackage(emailTitle);
      }

      this.closePopup();
    },
    downloadFile(content, fileName, contentType) {
      const a = document.createElement('a');
      const file = new Blob([content], { type: contentType });
      a.href = URL.createObjectURL(file);
      a.download = fileName;
      a.click();
    },
    async createDeploymentPackage(emailTitle) {
      const zip = new JSZip();
      const jsonData = {
        ...this.emailData,
        mediaQueries: this.mediaQueries, // Insert Media Queries here
        mapping: this.xPathPlaceholders, // Insert Placeholder Mapping here
      };
      zip.file(`${emailTitle}.json`, JSON.stringify(jsonData, null, 2));// zip the json file

      const htmlFile = convertJsonToHtml(this.emailData, false);
      zip.file(`${emailTitle}.html`, htmlFile); //zip the html file

      const xslFile = generateForDocEngine();
      zip.file(`${emailTitle}_html.xsl`, xslFile); //zip the xsl file

      const xmlData = this.xmlFile
      zip.file('design.xml', xmlData); // XML-Datei einfügen

      const metaData = generateMetaXML()
      zip.file('meta.xml', metaData) 

      const content = await zip.generateAsync({ type: 'blob' });
      saveAs(content, `${emailTitle}.edepp`);
    },
    closePopup() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  text-align: left;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input,
select {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.invalid {
  border-color: red;
}

.error-message {
  color: red;
  font-size: 12px;
}

.button-group {
  display: flex;
  justify-content: space-between;
}

button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button[disabled] {
  background: #ccc;
  cursor: not-allowed;
}

button:not([disabled]) {
  background: var(--primary-color);
  color: white;
}

button:not([disabled]):hover {
  background: var(--primary-color);
}
</style>